import gsap from "gsap"

export class InfrastructureCard {
  constructor() {
    this.isInitialized = false
    this.resizeHandler = null
    this.hoverTimelines = []

    this.infrastructureCardWraps = gsap.utils.toArray(".infrastructure_card_wrap")
  }

  init() {
    if (this.isInitialized) return
    const isMobile = window.innerWidth < 992

    if (!isMobile)
      this.initDesktopAnimation()
    else {
      this.infrastructureCardLogosWraps = document.querySelector(".infrastructure_card_logos_wrap");
      this.infrastructureCardPlus = document.querySelectorAll(".infrastructure_card_plus");
      this.initMobileAnimation()
    }
    this.bindResize()
    this.isInitialized = true

  }

  initDesktopAnimation() {
    this.cleanup()

    this.infrastructureCardWraps.forEach((wrap) => {
      const logos = wrap.querySelectorAll(".infrastructure_card_logos")

      // Create a timeline for this card
      const tl = gsap.timeline({ paused: true })
        .fromTo(logos,
          {
            y: "0%",
            opacity: 0
          },
          {
            y: "10%",
            opacity: 1,
            duration: 0.6,
            stagger: {
              each: 0.02,
              from: "center"
            },
            ease: "power2.out"
          }
        )

      // Hover handlers
      const hoverIn = () => tl.timeScale(1).play()
      const hoverOut = () => tl.timeScale(1.5).reverse()

      // Bind events
      wrap.addEventListener("mouseenter", hoverIn)
      wrap.addEventListener("mouseleave", hoverOut)

      // Store for cleanup
      this.hoverTimelines.push({ tl, wrap, hoverIn, hoverOut })
    })
  }

  initMobileAnimation() {
    this.cleanup()
    this.mobileClickHandlers = []

    this.infrastructureCardWraps.forEach((wrap) => {
      const logosWrap = wrap.querySelector(".infrastructure_card_logos_wrap")
      const cardPlus = wrap.querySelector(".infrastructure_card_plus")

      if (!logosWrap || !cardPlus) return

      // Get the SVG and the second path (vertical bar)
      const svg = cardPlus.querySelector("svg")
      const verticalPath = svg ? svg.querySelector("path:nth-child(2)") : null

      gsap.set(logosWrap, { height: 0 })

      const clickHandler = () => {
        const isExpanded = cardPlus.getAttribute("aria-expanded") === "true"

        // Animate the logos wrap
        gsap.to(logosWrap, {
          height: isExpanded ? 0 : "auto",
          duration: 0.3,
          ease: "power2.inOut"
        })

        // Animate the SVG rotation
        gsap.to(svg, {
          rotation: isExpanded ? 0 : 180,
          duration: 0.3,
          ease: "power2.inOut"
        })

        // Animate the vertical path fade
        if (verticalPath) {
          gsap.to(verticalPath, {
            opacity: isExpanded ? 1 : 0,
            duration: 0.3,
            ease: "power2.inOut"
          })
        }

        cardPlus.setAttribute("aria-expanded", isExpanded ? "false" : "true")
      }

      cardPlus.addEventListener("click", clickHandler)
      this.mobileClickHandlers.push({ cardPlus, clickHandler })
    })
  }

  bindResize() {
    this.resizeHandler = this.debounceResize(() => {
      this.init()
    }, 250)
    window.addEventListener("resize", this.resizeHandler)
  }

  debounceResize(fn, ms) {
    let last = innerWidth
    let timer
    return function (...args) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        if (innerWidth !== last) {
          last = innerWidth
          fn.apply(this, args)
        }
      }, ms)
    }
  }

  cleanup() {
    this.hoverTimelines.forEach(({ tl, wrap, hoverIn, hoverOut }) => {
      tl.kill()
      wrap.removeEventListener("mouseenter", hoverIn)
      wrap.removeEventListener("mouseleave", hoverOut)
    })
    this.hoverTimelines = []

    if (this.mobileClickHandlers) {
      this.mobileClickHandlers.forEach(({ cardPlus, clickHandler }) => {
        cardPlus.removeEventListener("click", clickHandler)
      })
      this.mobileClickHandlers = []
    }
  }

  destroy() {
    this.cleanup()
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler)
      this.resizeHandler = null
    }

    this.isInitialized = false
  }
}